import { FormattedMessage } from 'react-intl';

import { Button } from '@/components/ui/button';
import {
  Sheet,
  SheetContent,
  SheetFooter,
  SheetHeader,
  SheetTitle,
} from '@/components/ui/sheet';
import { useJobPostingContext } from '@/contexts/job-posting-context';

import { MessageContent } from './message-content';

interface MessageModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  openingId: string;
}

export function MessageModal({
  open,
  onOpenChange,
  openingId,
}: MessageModalProps) {
  const { hookForm } = useJobPostingContext();
  const { trigger } = hookForm;

  const handleCancel = () => {
    onOpenChange(false);
  };

  const handleSave = async () => {
    const isValidBody = await trigger(`pool.openingMessages.${openingId}.body`);
    const isValidSubject = await trigger(
      `pool.openingMessages.${openingId}.subject`,
    );
    if (!isValidBody || !isValidSubject) return;

    onOpenChange(false);
  };

  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent side="right" className="min-w-[570px] overflow-hidden">
        <SheetHeader>
          <SheetTitle>
            <FormattedMessage
              defaultMessage="Write campaign message"
              description="Title of the message modal"
            />
          </SheetTitle>
        </SheetHeader>

        <MessageContent openingId={openingId} />

        <SheetFooter>
          <Button variant="secondary" type="button" onClick={handleCancel}>
            <FormattedMessage
              defaultMessage="Cancel"
              description="Cancel button in the message modal"
            />
          </Button>
          <Button type="button" onClick={handleSave}>
            <FormattedMessage
              defaultMessage="Save"
              description="Save button in the message modal"
            />
          </Button>
        </SheetFooter>
      </SheetContent>
    </Sheet>
  );
}
